import { create } from 'zustand';

type IwUiStoreStore = {
  sidebarOpened: boolean | null;
  toggleSidebar: (value: boolean) => void;
};

export const useIwUiStore = create<IwUiStoreStore>((set) => ({
  sidebarOpened: null,
  toggleSidebar: (sidebarOpened) => set({ sidebarOpened }),
}));
